
import { CommentType } from '@/components/reader-home/types';

// Mock data - enhanced with community features and nested replies
export const mockComments: CommentType[] = [
  {
    id: 1,
    user: {
      name: "Alex Thompson",
      avatar: "/placeholder.svg",
      bio: "Environmental policy researcher and avid reader",
      joinDate: "Member since Jan 2023"
    },
    content: "This article provides a comprehensive overview of renewable energy in urban settings. I particularly appreciated the discussion on building-integrated photovoltaics.",
    likes: 15,
    dislikes: 2,
    timestamp: "2 hours ago",
    topics: ["Building-Integrated Photovoltaics", "Urban Energy", "Technology"],
    replies: [
      {
        id: 11,
        user: {
          name: "Emma Johnson",
          avatar: "/placeholder.svg",
          isJournalist: true,
          bio: "Environmental journalist focusing on urban sustainability",
          joinDate: "Journalist since 2018"
        },
        content: "Thank you for your thoughtful comment, Alex! Building-integrated photovoltaics is indeed a promising technology that deserves more attention. I'm planning a follow-up piece that goes deeper into implementation challenges.",
        likes: 8,
        dislikes: 0,
        timestamp: "1 hour ago",
        highlighted: true,
        parentId: 1,
        topics: ["Building-Integrated Photovoltaics", "Implementation Challenges"],
        replies: [
          {
            id: 111,
            user: {
              name: "Alex Thompson",
              avatar: "/placeholder.svg",
              bio: "Environmental policy researcher and avid reader",
              joinDate: "Member since Jan 2023"
            },
            content: "I'd love to read that follow-up piece! Are there any specific challenges you're planning to address regarding cost efficiency?",
            likes: 3,
            dislikes: 0,
            timestamp: "45 minutes ago",
            parentId: 11,
            topics: ["Cost Efficiency", "Implementation Challenges"],
            replies: []
          }
        ]
      },
      {
        id: 12,
        user: {
          name: "Jamie Carter",
          avatar: "/placeholder.svg",
          bio: "Urban planner with focus on sustainable development",
          joinDate: "Member since Mar 2022"
        },
        content: "I agree! BIPV is definitely the way forward for sustainable urban development. I've seen some incredible implementations in Barcelona recently.",
        likes: 3,
        dislikes: 1,
        timestamp: "45 minutes ago",
        parentId: 1,
        topics: ["Building-Integrated Photovoltaics", "Urban Development", "Barcelona"],
        replies: []
      }
    ]
  },
  {
    id: 2,
    user: {
      name: "Morgan Lee",
      avatar: "/placeholder.svg",
      bio: "Climate policy advisor and technology enthusiast",
      joinDate: "Member since Oct 2021"
    },
    content: "I would have liked to see more discussion on the challenges of implementing these technologies in existing urban infrastructure, but overall a great read!",
    likes: 7,
    dislikes: 3,
    timestamp: "5 hours ago",
    topics: ["Urban Infrastructure", "Implementation Challenges"],
    replies: [
      {
        id: 21,
        user: {
          name: "Robin Patel",
          avatar: "/placeholder.svg",
          bio: "Architect specializing in sustainable retrofits",
          joinDate: "Member since Dec 2021"
        },
        content: "Agreed. Retrofitting existing buildings is often more complex than implementing these technologies in new construction. I think this deserves its own article.",
        likes: 4,
        dislikes: 0,
        timestamp: "4 hours ago",
        parentId: 2,
        topics: ["Retrofitting", "Urban Infrastructure"],
        replies: [
          {
            id: 211,
            user: {
              name: "Morgan Lee",
              avatar: "/placeholder.svg",
              bio: "Climate policy advisor and technology enthusiast",
              joinDate: "Member since Oct 2021"
            },
            content: "Exactly my point! The policy implications for retrofitting are also quite different from new construction regulations.",
            likes: 2,
            dislikes: 0,
            timestamp: "3 hours ago",
            parentId: 21,
            topics: ["Policy", "Retrofitting"],
            replies: []
          }
        ]
      }
    ]
  },
  {
    id: 3,
    user: {
      name: "Taylor Rivera",
      avatar: "/placeholder.svg",
      bio: "Renewable energy consultant and frequent commenter",
      joinDate: "Member since Jun 2020"
    },
    content: "The section on waste-to-energy systems was particularly enlightening. I work in this field and find that many articles overlook this important aspect of urban sustainability.",
    likes: 22,
    dislikes: 1,
    timestamp: "1 day ago",
    highlighted: true,
    topics: ["Waste-to-Energy", "Urban Sustainability"],
    replies: []
  }
];
